/**
 * Companies ID's
 */
export enum COMPANIES_ID {
  DET = 1,
  ZUBLIN = 2,
  DCH = 3,
  HCM = 4,
  PYT = 5,
  MTV = 6
}
